<template>
  <div class="product">
    <div v-if="imageUrl">
      <div class="img-wrap" @click="$emit('view-product', item)" >
        <img
          class="list-complete-img"
          :src="
            item.image
              ? item.image
              : require('../../../assets/images/default-img.jpg')
          "
          :alt="item.name"
        />

        <div class="cstagscontainer" v-if="item.cs_tags.name">
          {{ item.cs_tags.name }}
        </div>
      </div>
    </div>
    <div v-else>
      <div class="img-wrap default" @click="$emit('view-product', item)">
        <img
          class="list-complete-img"
          src="../../../assets/images/default-img.jpg"
          :alt="item.name"
        />
        <div class="cstagscontainer" v-if="item.cs_tags.name">
          {{ item.cs_tags.name }}
        </div>
      </div>
    </div>

    <div class="product-info">
      <div class="top-container">
        <div class="product-names">
          <a-tooltip v-if="mobileView" :title="item.name">
            <div class="name" id="product-name">
              {{ item.name.substring(0, 30) }}...
            </div>
          </a-tooltip>
          <a-tooltip v-else :title="item.name">
            <div class="name" id="product-name">
              {{ item.name.substring(0, 40) }}...
            </div>
          </a-tooltip>
        </div>

        <div class="tagscontainer" id="product-tags">
          <div
            v-for="tag in item.tags_info"
            v-bind:key="tag.id"
            class="tagsstyle"
          >
            <a class="taglink" @click="getTagUrl(tag.name)">
              {{ tag.name }}
            </a>
          </div>
        </div>
      </div>
      
      <div class="view-details-out">
        <a class="view-details" :href="getVUrl(item.id)"> View Details </a>

        </div>
     

      <div class="bottom-container">
        <div class="prices">
          <div
            v-if="Number(item.before_price) > Number(item.after_price)"
            class="price beforeprice"
          >
            Rs.{{ item.before_price }}
          </div>

          <div class="price">Rs.{{ item.after_price }}</div>
        </div>

        <div class="order-button-wrap">
          <a-tooltip>
            <template slot="title">Add to cart</template>
            <div
              class="add"
              :class="{ active: !add }"
              @click="addToCartCall(item)"
            >
              Add
            </div>
          </a-tooltip>
          <div class="added" :class="{ active: add }">
            <a-button
              class="order-button minus"
              icon="minus"
              @click="decreaseQuantity(item.id)"
            />
            {{ quantity }}
            <a-button
              class="order-button plus"
              icon="plus"
              @click="increaseQuantity(item.id)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { CartData } from "../../../services/storage.service";
import isEmpty from "../../../utils/isEmpty";
import isUrl from "../../../utils/isUrl";
import { LocationId } from "../../../services/storage.service";
import router from "../../../router";

export default {
  name: "HomePageProductNew",
  props: ["item"],
  data() {
    return {
      add: false,
      quantity: 1,
      itemId: null,
      imageUrl: false,
      popUpOn: 0,
      tags: [],
      mobileView: false,
    };
  },
  created() {
    this.itemId = this.item.id;

    window.addEventListener("resize", this.handleWindowResize);
    this.handleWindowResize();
    // console.log(this.item);
    if (this.item.image !== "") {
      if (isUrl(this.item.image)) {
        this.imageUrl = true;
      }
    }
    if (this.cartItems.filter((food) => food.id === this.item.id).length > 0) {
      this.add = true;
    }

    let itemtags = this.item.tags.split(",");
    this.tags = itemtags.filter((data) => data);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
  },
  watch: {
    // whenever question changes, this function will run
    cartItems: function(newCartItems, oldCartItems) {
      CartData.setCartItems(newCartItems);
      if (newCartItems.length === 0) {
        (this.add = false), (this.quantity = 1);
        return;
      } else if (
        newCartItems.filter((food) => food.id === this.itemId).length === 0
      ) {
        (this.add = false), (this.quantity = 1);
        return;
      } else {
        this.quantity = newCartItems.filter(
          (food) => food.id === this.itemId
        )[0].quantity;
      }
    },
  },
  computed: {
    ...mapGetters(["cartItems"]),
  },
  methods: {
    ...mapActions(["addToCart", "addQuantity", "minusQuantity", "deleteItem"]),
  
    addToCartCall(item) {
      this.add = !this.add;
      this.addToCart(item);
    },
    increaseQuantity(id) {
      this.addQuantity(id);
    },
    decreaseQuantity(id) {
      if (this.quantity === 1) {
        this.add = false;
        this.deleteItem(id);
      } else {
        this.minusQuantity(id);
      }
    },
    getVUrl: function (item) {
      if (LocationId.getLocationId() == 1) return "/ktm/i/" + item;
      else if (LocationId.getLocationId() == 2) return "/pkr/i/" + item;
    },
    getTagUrl: function(item) {
      if (LocationId.getLocationId() == 1) {
        this.$router.replace({
          name: "Search",
          params: { loc: "ktm" },
          query: { q: item },
        });
      } else if (LocationId.getLocationId() == 2) {
        this.$router.replace({
          name: "Search",
          params: { loc: "pkr" },
          query: { q: item },
        });
      }
    },
    handleWindowResize() {
      if (window.innerWidth <= 640) {
        this.mobileView = true;
      } else {
        this.mobileView = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

// .popup {
//   position: fixed;
//   width: 100%;
//   height: 100%;
//   top: 0;
//   left: 0;
//   z-index: 9999;

//   .backdrop {
//     widows: 100%;
//     height: 100%;
//     background: rgba(0, 0, 0, 0.2);
//     cursor: pointer;
//   }
//   .popupItem {
//     padding: 10px;
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     transform: translate(-50%, -50%);
//     background: #fff;
//     border-radius: 10px;
//     box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.2);

//     .cross {
//       color: white;
//       text-align: right;
//       font-weight: bold;
//       cursor: pointer;
//       background: red;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//     }
//   }
// }

// .popup-img {
//   width: 300px;
// }

// .des-name {
//   font-style: italic;
//   margin-bottom: 19px;
// }

// .view-details {
//   display: inline-block;
//   margin-bottom: 20px;
// }

.add {
  // border: 1px solid black;
  background-color: #ed2027;
  border-radius: 14px;
}

.price {
  display: inline-block;
}

.beforeprice {
  text-decoration: line-through;
  color: #ccc !important;
  margin-right: 10px;
}

.tagscontainer {
  display: block;
  min-height: 0px;
  overflow: hidden;
  margin-top: 10px;
  max-height: 52px;
}

.tagsstyle {
  background: #efefef;
  margin: 3px;
  padding: 3px 5px;
  height: "auto";
  color: #333;
  font-family: $main-font;
  font-size: 10px;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  text-transform: capitalize;
}

.taglink {
  color: #333;
}

.taglink:hover {
  color: #333;
}

.bottom-container {
  min-height: 50px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 30px;
}

.top-container {
  height: 170px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.cstagscontainer {
  background-color: #ff6f30;
  position: absolute;
  border-radius: 10px;
  padding: 5px;
  top: 209px;
  width: auto;
  text-transform: capitalize;
  color: #fff;
  font-family: $main-font;
  font-size: 10px;
  z-index: 9;
  display: flex;
  height: 22px;
  align-items: center;
  justify-content: center;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.cstagscontainer-vd {
  background-color: transparent;
  position: relative;
  top: -11px;
  text-align: center;
  width: 20;
  text-transform: capitalize;
  color: #fff;
  font-family: $main-font;
  font-size: 10px;
  display: flex;
  height: 22px;
  align-items: center;
  justify-content: center;
  .cstagstext-vd {
    background-color: #ff6f30;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
      rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    padding: 5px;
    border-radius: 10px;
  }
}

.img-wrap {
  background-color: #fff;
  // width: 10000px;
}

// .img-wrap>img{
//   border: 3px solid red;
//   // width: 30px;
// }

.popup-test {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 9999;
}
</style>
